import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20luxurious%20dark%20abstract%20background%20with%20golden%20and%20amber%20flowing%20lines%2C%20geometric%20patterns%2C%20elegant%20atmospheric%20composition%2C%20premium%20dark%20texture%20with%20warm%20golden%20accents%2C%20cinematic%20lighting%20with%20soft%20glow%20effects%2C%20no%20text%2C%20no%20logos%2C%20clean%20professional%20background%20suitable%20for%20gaming%20and%20entertainment%20platform%20website%20hero&width=1600&height=900&seq=hero-kaiyun-2026&orientation=landscape"
          alt="开云官网 - 官方平台入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col items-center text-center w-full">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 text-primary-500 text-sm font-medium mb-6 whitespace-nowrap">
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center"></i>
            官方正版 · 安全认证
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-6 max-w-3xl">
            开云官网
            <span className="block text-xl md:text-3xl lg:text-4xl mt-2 text-primary-500 font-heading">
              官方正版入口 · 安全登录体验
            </span>
          </h1>

          <p className="text-base md:text-lg text-secondary-300 max-w-2xl mb-10 leading-relaxed">
            开云官网是您访问开云平台的官方正版渠道，提供安全稳定的登录入口、丰富的产品服务与极致用户体验。专业团队全天候支持，保障您的账户安全与资金安全。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <Link
              to="/"
              className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40 whitespace-nowrap cursor-pointer"
            >
              立即注册
            </Link>
            <Link
              to="/categories"
              className="px-8 py-3.5 rounded-lg border border-secondary-400/40 text-foreground-800 font-medium text-base hover:bg-background-200/40 hover:border-secondary-400/60 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              浏览服务
              <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-8 md:gap-16 mt-16">
            {[
              { value: '500万+', label: '注册用户' },
              { value: '7×24', label: '全天候服务' },
              { value: '99.9%', label: '平台稳定性' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-sm text-secondary-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}